var O = /* @__PURE__ */ ((T) => (T.TOOLTIP = "tooltip", T.POPOVER = "popover", T))(O || {}), E = /* @__PURE__ */ ((T) => (T.TOP = "top", T.TOP_LEFT = "top-left", T.RIGHT = "right", T.BOTTOM = "bottom", T.BOTTOM_LEFT = "bottom-left", T.LEFT = "left", T))(E || {}), l = /* @__PURE__ */ ((T) => (T.MEDIUM = "medium", T.WIDE = "wide", T))(l || {});
export {
  E as PopoverContainerPosition,
  l as PopoverContainerSize,
  O as PopoverContainerVariant
};
